<template>
  <div></div>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ApiClient from '../../services'
import { SPOTIFY_CLIENT, SCOPE_LIST } from '../../config'
import { convertToEncodeURI, getConfigForNetwork } from '../../utils'

const config = getConfigForNetwork()

@Component({})
export default class Auth extends Vue {
  grantContent = ''
  async mounted() {
    const params = {
      client_id: SPOTIFY_CLIENT.CLIENT_ID,
      response_type: 'code',
      redirect_uri: `${config.frontendURL}/auth/callback`,
      scope: this.scope
    }
    const URL = convertToEncodeURI(`https://accounts.spotify.com/authorize`, params)
    window.location = URL
  }
  get scope() {
    return SCOPE_LIST.join(' ')
  }
}
</script>
